import React, { useState, useEffect, useRef, useContext } from 'react';
import { Link, NavLink } from 'react-router-dom';

function HeaderComponent({ closeModal, accountName, logout, closeMod, login, spendSpn, getSpn, spnCurr, waxprice, setModalResulOpen }) {
    return (
        <>
            <header>
                {accountName ?
                    <>
                        <div className="user-name">
                            Welcome, {accountName}
                        </div>
                        <nav>
                            <ul>
                                <li>
                                    <button onClick={() => logout()}>Logout</button>
                                </li>
                                <li>
                                    <Link to="/">
                                        home
                                    </Link>
                                </li>
                                <li>
                                    <Link to="/market">
                                        price on market
                                    </Link>
                                </li>
                            </ul>
                        </nav>
                    </>
                    :
                    <>
                        <nav>
                            <ul>
                                <li>
                                    <button onClick={() => closeModal(false)}>
                                        Login
                                    </button>
                                </li>
                                <li>
                                    <Link to="/">
                                        home
                                    </Link>
                                </li>
                                <li>
                                    <Link to="/market">
                                        price on market
                                    </Link>
                                </li>
                            </ul>
                        </nav>
                    </>

                }

                <div className="info-calc">
                    <div className="curr">
                        curr:  1 SPN = {waxprice.toFixed(4)} WAX
                    </div>
                    <div className="spend-spn">
                        spend SPN: <span>{spendSpn ? spendSpn.toFixed(4) : 0}</span>
                    </div>
                    <div className="get-spn">
                        get SPN: <span>{getSpn ? getSpn.toFixed(4) : 0}</span>
                    </div>
                    <div className="detal-info">
                        <span className='bt' onClick={() => setModalResulOpen(true)}>
                            detal Info
                        </span>
                    </div>
                </div>
            </header>
        </>
    );
}

export default HeaderComponent;
